import Slider from './_slider';
import app from "../_app";

const sliderElements = [...document.querySelectorAll('.js-usp-slider')];

if(app.viewport.isSmallerThan('lg')) {

    sliderElements.map(sliderElement => {
        const slider = new Slider(sliderElement, {
            autoplay: sliderElement.hasAttribute('data-autoplay'),
            arrows: false,
            dots: true
        });
    });
}